<template>
	<div class='content'>
		<van-nav-bar
			   title="团体输入信息提交"
			   left-text=""
			   right-text=""
			   left-arrow
			   @click-left="onClickLeft"
			  @click-right="onClickRight"
			/>
	   <van-cell-group class="box">
		  <van-field
		  	  required
			  clickable
			  name="calendar"
			  v-model="timeDate"
			  label="游玩日期"
			  placeholder="点击选择日期"
			  left-icon="underway-o"
		      class='icon_color1'
			  @click="showCalendar = true"
			/>
			<van-calendar v-model="showCalendar" @confirm="onConfirm" />
		  <van-field
		    v-model="name"
		    clearable
		    label="领队姓名"
		    left-icon="manager"
		    required
		    placeholder="请输入姓名"
		    class='icon_color1'
		  />
		  <van-field
		    v-model="phone"
		    clearable
		    required
		    label="手机号码"
		    left-icon="phone-circle"
		    placeholder="请输入电话号码"
		    class='icon_color2'
		  />
		  <van-field
		    v-model="ID_card"
		    clearable
		    required
		    label="身份证号"
		    left-icon="debit-pay"
		    placeholder="请输入身份证"
		     class='icon_color2'
		  />
		</van-cell-group>
		 <van-field
		    v-model="makr"
		    clearable
		    required
		    label="预约单位"
		    left-icon="debit-pay"
		    placeholder="请输入单位信息"
		    class='icon_color2'
		  />
		   <van-field
		   	 v-on:input="search" 
		    v-model="people"
		    clearable
		    required
		    type="number"
		    label="预约人数"
		    left-icon="manager"
		    placeholder="请输入预约人数最少5人"
		    class='icon_color2'
		  />
		</van-cell-group>
		<div class="box_visit">
			<!--<p>
			    <van-icon name="bars" />
				订单：{{order}}
				</p>-->
			<p v-if="hide1"><van-icon name="balance-o"  color="#4fc08d"/>
				
				可预约人数：{{numlist_}}
			</p>	
			<p v-if="hide"><van-icon name="balance-o"  color="#4fc08d"/>
				
				金额：{{total}}
			</p>
			<p><van-icon name="balance-o"  color="#4fc08d"/>
				
				价格：{{total_}}
			</p>
			<p v-if="hide">
				<van-icon name="bars"  color="#1989fa"/>
				数量：{{numlist}}
			</p>
			<p>
				<van-icon name="bars"  color="#1989fa"/>
				人数：{{numlistdata}}
			</p>
		</div>
	    
		<!--<van-tabbar v-model="active">
		  
		   <van-tabbar-item icon="home-o"><router-link to="/wx_ticketIndex" class="router" >购票首页</router-link></van-tabbar-item>
		   <van-tabbar-item icon="search"><router-link to="/wx_ticketOrder" class="router activerouter">我的订单</router-link></van-tabbar-item>
		   <van-tabbar-item icon="setting-o"><router-link to="/wx_ticketUser" class="router">个人中心</router-link></van-tabbar-item>
		</van-tabbar>-->
		<van-submit-bar  button-text="预约提交" :disabled="isDisable"  @submit="onSubmit">
		
		  <template >
		  	 <div id="numlist" >
		  	 	
		  	 	 <van-row >
				  	  <van-col span="24">
				  	  	
				  	  	 <van-col span="12">
				  	 	   <span style="margin-left: 3px;">人数:{{numlistdata}}</span>
				  	 	  </van-col>
				  	     <van-col span="12">
				  	        <span class="total" >总价:{{total_}}</span>
					   	  </van-col>
	 	    	    </van-col>
			   </van-row>
		  	
	 	    	 
 	    	 </div>
		  </template>
		</van-submit-bar>
	</div>
</template>

<script>

  export default {
  data () {
    return {
    	hide1:false,
    	 numlistdata:"0",
    	 total_:'0',
    	 makr:'',
    	 people:'',
    	 isDisable:false,
    	 order:'',
    	 total:'',
    	 numlist:'',
    	 totala:'',
    	 numlista:'',
    	 timeDate:'',
    	 currentDate: new Date(),
    	 phone:'',
   	     ID_card: '',
   	     name :"游客",
	     message:'',
	     isLoadingShow: true,
    	 hide:false,
         loading: false,
	     finished: false,
         show: false,
         className: '',
         showCalendar: false,
         ticketlist: [],
         numlist_:"",
	    }
    },
    mounted(){
    	this.time();
    	this.onLoadtime()
    },
	methods: {
		onLoadtime() {
		 	let time = this.timeDate;
		 	console.log(time)
		 	this.$axios({
		            url: "/api/sell/getRemainTicketCount",
		            method: "post",
		            data: {
		               
						datepicker: time,
		            },
		            headers: {
		              "Content-Type": "application/json; charset=utf-8"
		            }
		            })
			    	.then(res => {
			    		console.log(res.data)
			    	   this.numlist_=res.data.remainTicketCount;
			    	})
    			  .catch(err => {
	              console.log(err);
	              this.$notify({ type: 'warning', message: '获取不到可预约人数' });
		     
	        });
	          
	       
	    },
		
		
	   onLoad() {
	        this.loading = false;
			this.finished = true;
	       
	    },
	    onClickLeft(){
			this.$router.push({ path: "/mn_ticketGroup" });
		},
		onClickRight(){},
	    search(){
  				this.total_ = this.people*this.total;
  				this.numlistdata = this.people*this.numlist;
      	},
	     
		 // 选项格式化函数
		 onSubmit(){
		 	
		 	this.ticketlist=[];
		 	this.isDisable = true ;
			    setTimeout(() => {
			     this.isDisable = false
		    }, 1000)
		    let name =this.name;
		 	let phone =this.phone;
		 	let people =this.people;
		 	let numlist_ =this.numlist_;
		 	
		 	let ID_card =this.ID_card;
		 	let num =  Number(this.numlistdata);
		 	let makr = this.makr;
		 	let id = Number(this.$route.query.ticketArray);
		 	
			 if(name==""){
		      	 this.$notify({ type: 'warning', message: '请输入游客姓名' });
				 return;
		        }	
	        if(name.length>12){
	      	  this.$notify({ type: 'warning', message: '输入姓名不能大于12个字符' });
			  return;
	        }
	        
      		if(phone==""){
		      	this.$notify({ type: 'warning', message: '请输入电话号码' });
				return;
		      }
      	    if( (!(/^[1][345789]\d{9}$/).test(phone) || !(/^[1-9]\d*$/).test(phone) || phone.length !== 11) ){
		      	this.$notify({ type: 'warning', message: '电话号码不符合规格' });
				return;
		     }	
			if(ID_card ==""){
	      		this.$notify({ type: 'warning', message: '请输入身份证号码' });
		        return;
		      }	
		     if(makr ==""){
	      		this.$notify({ type: 'warning', message: '请输入单位' });
		        return;
		      }	
		      if(makr.length>18){
	      		this.$notify({ type: 'warning', message: '单位名称不能大于18个字符' });
		        return;
		      }	
		    if(people ==""){
	      		this.$notify({ type: 'warning', message: '请输入人数' });
		        return;
		      }	  
		      
		    if(people < 2){
	      		this.$notify({ type: 'warning', message: '团队人数不能小于2' });
		        return;
		      }	
		      if(people > 200){
	      		this.$notify({ type: 'warning', message: '团队人数不能大于200' });
		        return;
		      }
		      
		      
		      if(people>numlist_){
		      	this.$notify({ type: 'warning', message: '剩余预约人数的名额不够' });
		        return;
		      }
		      if(numlist_=="false"){
		      	this.$notify({ type: 'warning', message: '可能网络原因获取预约人数失败,请在重新选择购票试试' });
		        return;
		      }
		      
		      
		     let returnParam  = this.ID_cardlist(ID_card);
			 let isPass = returnParam.isPass;
			 if(isPass==false){
				this.$notify({ type: 'warning', message: '请输入正确的身份证号码' });
		        return;
			}
			 
			let total= this.total_;
			this.ticketlist.push({ticketTypeID:id,ticketCount:num})
		
			let storage=window.sessionStorage;
    		let openida = storage.getItem("openid")
    		
    		if(total==0){
    			if(num>0){
    				this.$axios({
		            url: "/api/sell/wxSubmitOrder",
		            method: "post",
		            data: {
		                openid: openida,
						orderAmount: total
		            },
		            headers: {
		              "Content-Type": "application/json; charset=utf-8"
		            }
		            })
			    	.then(res => {
			    		console.log(res.data)
			    	    let data =res.data.JSAPI_result;
			    	    if(res.data.result_msg==""){
			    	   	  this.order_list(data.orderID);
			    	   	  
			    	   }
			    	})
    			}
    			
			    
    		}
    		else {
		    this.$axios({
		            url: "/api/sell/wxSubmitOrder",
		            method: "post",
		            data: {
		                openid: openida,
						orderAmount: total
		            },
		            headers: {
		              "Content-Type": "application/json; charset=utf-8"
		            }
			    })
				.then(res => {
					let datalist =res.data;
					
					let data =res.data.JSAPI_result;
					
					
					if (datalist.result_msg == '失败') {
						alert("支付失败，请重新进入系统购票");
					} else {
						if (typeof WeixinJSBridge == "undefined") {
							if (document.addEventListener) {
								document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(data.appid, data.timeStamp, data.nonceStr, data.prepayID, data.paySign, data.orderID), false);
							} else if (document.attachEvent) {
								document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(data.appid, data.timeStamp, data.nonceStr, data.prepayID, data.paySign, data.orderID));
								document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(data.appid, data.timeStamp, data.nonceStr, data.prepayID, data.paySign, data.orderID));
							}
						} else {
							
							 this.onBridgeReady(data.appid, data.timeStamp, data.nonceStr, data.prepayID, data.paySign, data.orderID);
						}
					}
				})
				
	            .catch(err => {
	              console.log(err);
	              this.$notify({ type: 'warning', message: '调取支付失败' });
		     
	        });
	       }
		 },
		 
		 order_list(orderID){
		 	let name =this.name;
		 	let time="";
		    var nowDate = new Date();
            var year = nowDate.getFullYear();
            var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1):nowDate.getMonth() + 1;
            var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
            var timelist = year + "-" + month + "-" + day;
			
 			if(time==timelist){
		 		 time = this.timeDate;
		 	}else{
		 		 time = this.timeDate+" " + "00:00:00";
		 	}
	
		    this.ticketlist=[];
		 	let phone =this.phone;
		 	let people =this.people;
		 	let ID_card =this.ID_card;
		 	let num =  Number(this.numlistdata);
		 	let makr = this.makr;
		 	let id = Number(this.$route.query.ticketArray);
		 	let total= this.total_;
		 	
		 	this.ticketlist.push({ticketTypeID:id,ticketCount:num})
			let storage=window.sessionStorage;
    		let openida = storage.getItem("openid");
    		var ticketArray =this.ticketlist;
    		
    		this.$axios({
				    url: "/api/sell/wxConfirmOrder",
				            method: "post",
				            data: {
				            	openid: openida,
				            	orderID:orderID,
				            	touristIDCardNum:ID_card,//身份证
				            	touristMobile:phone,//电话
				            	ticketStartTime:time,//游玩时间
				                touristName: name,//姓名
				                orderAmount:total,
				                touristCompany:makr,//单位
				                ticketArray:ticketArray,//票数组
				            },
				            headers: {
				              "Content-Type": "application/json; charset=utf-8"
			   }
			 		 }) .then(res => {
				              console.log(res.data);
				              if (res.data.orderID !== "" ) {
				                alert("预约成功");
				                this.$router.push({ path: "/mn_ticketOrderlist"});
				              } else {
				               /* this.$message({
				                  showClose: true,
				                  message: res.data.errMsg,
				                  type: "error",
				                  duration: 5000
				                });*/
				                 alert("预约失败");
				              }
				            })
				            .catch(err => {
				              console.log(err);
				              alert("数据连接异常，预约失败");
				            });
    		
		 },
	    onBridgeReady(appid, timeStamp, nonceStr, prepay_id, paySign, orderID) {
	    	    let thta =this;
	    	    let storage=window.sessionStorage;
				var openid = storage.getItem("openid")
  			    var ticketArray =thta.ticketlist;
	      		var ID_card =thta.ID_card;
	      		var name =thta.name;
	      		var time= "";
	      		var phone =thta.phone;
	      		var total =thta.total_;
	      	    var touristCompany = thta.makr;
	      	  
			    var nowDate = new Date();
	            var year = nowDate.getFullYear();
	            var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1):nowDate.getMonth() + 1;
	            var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
	            var timelist = year + "-" + month + "-" + day;
			    if(time==timelist){
			 		 time = thta.timeDate;
			 	}else{
			 		 time = thta.timeDate+" " + "00:00:00";
			 	}
	    	    WeixinJSBridge.invoke(
			      'getBrandWCPayRequest', {
			        	"appId": appid,   
						"timeStamp": timeStamp,  
						"nonceStr": nonceStr, 
						"package": "prepay_id=" + prepay_id + "",
						"signType": "MD5",        
						"paySign": paySign 
			      },
			      function(res){
			           var temp =res.err_msg;
     				  if(temp.indexOf('ok')>-1){
			        	 thta.$axios({
				            url: "/api/sell/wxConfirmOrder",
				            method: "post",
				            data: {
				            	openid:openid,
				            	orderID:orderID,
				            	touristIDCardNum:ID_card,//身份证
				            	touristMobile:phone,//电话
				            	ticketStartTime:time,//游玩时间
				                touristName: name,//姓名
				                orderAmount:total,
				                touristCompany:touristCompany,//单位
				                ticketArray:ticketArray,//票数组
				            },
				            headers: {
				              "Content-Type": "application/json; charset=utf-8"
				            }
				          })
				            .then(res => {
				              console.log(res.data);
				              if (res.data.orderID !== "" ) {
				              /*  this.$message({
				                  showClose: true,
				                  message: "success,支付成功",
				                  type: "success",
				                  duration: 5000
				                });*/
				                //alert("支付成功");
				                //window.location.href = '/wx_ticketOrderlist';
				               thta.$router.push({ path: "/mn_ticketOrderlist"});
				              } else {
				               /* this.$message({
				                  showClose: true,
				                  message: res.data.errMsg,
				                  type: "error",
				                  duration: 5000
				                });*/
				                 alert("支付失败");
				              }
				            })
				            .catch(err => {
				              console.log(err);
				              alert("支付失败");
				            });
			     		 // 使用以上方式判断前端返回,微信团队郑重提示：
			            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
			     } 
			   }); 
			},	
        time(){
		       this.timeDate=this.dateFormat();
		       let storage=window.sessionStorage;
		       let openid = storage.getItem("openid")
    		   this.total =   this.$route.query.total;
    		   this.numlist =this.$route.query.numlist;
    		  }, 
		 onConfirm(date) {
	 	      var year=date.getFullYear();
	          var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1):date.getMonth() + 1;
              var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
		 	  this.timeDate = year+"-"+month+"-"+day
		 	  this.showCalendar = false;
		      this. onLoadtime() 
		      
		    },    
		dateFormat() {//获取当前时间
		    	 var date=new Date();
		         var year=date.getFullYear();
		         var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1):date.getMonth() + 1;
	             var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
		        //var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
		       // var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
		        //var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
		        return year+"-"+month+"-"+day
        },   
	     ID_cardlist(ID_card){
	       //身份证号前两位代表区域
	       var city={
	                 11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",
	                 21:"辽宁",22:"吉林", 23:"黑龙江 ",
	                 31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",
	                 41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",
	                 50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",
	                 61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",
	                 71:"台湾",
	                 81:"香港",82:"澳门",
	                 91:"国外 "
	       };
	       //身份证格式正则表达式
	       var idCardReg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
	       var errorMess = "";//错误提示信息
	       var isPass= true;//身份证验证是否通过（true通过、false未通过）
	
	    //如果身份证不满足格式正则表达式
	       if(!ID_card || !idCardReg.test(ID_card)){
	           errorMess = "您输入的身份证号格式有误！";
	           isPass= false;
	       }
	
	      //区域数组中不包含需验证的身份证前两位
	      else if(!city[ID_card.substr(0,2)]){
	           errorMess = "您输入的身份证地址编码有误！";
	           isPass= false;
	       }
	       else{
	           //18位身份证需要验证最后一位校验位
	           if(ID_card.length == 18){
	               ID_card = ID_card.split('');
	               //∑(ai×Wi)(mod 11)
	               //加权因子
	               var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
	               //校验位
	               var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
	               var sum = 0;
	               var ai = 0;
	               var wi = 0;
	               for (var i = 0; i < 17; i++)
	               {
	                   ai = ID_card[i];
	                   wi = factor[i];
	                   sum += ai * wi;
	               }
	               var last = parity[sum % 11];
	               if(parity[sum % 11] !== ID_card[17]){
	                   errorMess = "18身份证最后一位校验位验证有误！";
	                   isPass = false;
	               }
	           }
	       }
	       var returnParam = {
	           'errorMess' : errorMess ,
	           'isPass' : isPass 
	       }
	       return returnParam ;
	      },
         showPopup () {
	      this.show = true
	      this.isLoadingShow = true
	      setTimeout(() => {
	        this.isLoadingShow = false
	      }, 500)
    	},
    	
		 
	}
}
</script>

<style>
	#numlist span .button_{
	   display: inline-block;
	   width:40px;
	   height: 48px;
	   line-height: 48px;
	   font-size: 13px;
	   text-align: center;
	}
	#numlist span{
	   display: inline-block;
	   width:68px;
	   height: 48px;
	   line-height: 48px;
	   font-size: 13px;
	   text-align: center;
	}
	#numlist .total {
		text-align: left;
		 width:108px;
	}
	.icon_color1 i {
		color:#1989fa;
	}
	.icon_color2 i {
		color:#19c160;
	}
	.icon_color3 i {
		color:#07c160;
	}
	.icon_color4 i {
		color:#4fc08d;
	}
	.icon_color5 i {
		color:#2989fa;
	}
	.box_visit{
		width: 90%;
		margin-top:30px;
		margin-left: 5%;
		height: 100px;
		margin-bottom: 10px;
		
	}
</style>


// WEBPACK FOOTER //
// src/system/index/wechatlistmini/mn_ticketOrderGroup.vue